// import $public from '../../util/public.js'
export default {
	namespaced: true,
	state: {
		type:'list',
		addParams:{},
		money:0,
		activityMoney:0,
		remark:'',
	},
	getters: {
		
	},
	mutations: {
		set_type(state, params) {
			state.type = params;
		},
		set_addParams(state, obj) {
			state.addParams = obj;
		},
		set_money(state, params) {
			state.money = params;
		},
		set_activityMoney(state, params) {
			state.activityMoney = params;
		},
		set_remark(state, obj) {
			state.remark = obj;
		},
	},
	actions: {

	},
};
